import { render, staticRenderFns } from "./Clouds.vue?vue&type=template&id=10dedaa2&"
import script from "./Clouds.vue?vue&type=script&lang=js&"
export * from "./Clouds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports